import { AssignmentTypeEnum } from "../enums/assignmentType.enum";
import { PmUnitEnum } from "../enums/pmUnit.enum";
import { SampleTypeEnum } from "../enums/sampleType.enum";
import { ParameterPercentage } from "./parameter.model";

export class SensorAssignment {
  id: string;
  startDate: Date | number;
  endDate: Date | number | null;
  sensorId: string;
  sensorName: string;
  endPointId: string;
  endPointName: string;
  assignedBy: string;
  assignmentType: AssignmentTypeEnum;
  createdDate: Date | number;
  sampleNumber?: string;
  labResult?: string;
  samplingParameters?: string;
  sampleType?: SampleTypeEnum;
  isFinished: boolean;
  summaryNote?: string;
  segId: string;
  segName: string;
  totalTime: number;
  totalTimeMins: number;
  shiftLength: number;
  organizationLevelId: string;
  parameters: ParameterPercentage[];
  flowRateStart: number;
  flowRateEnd: number;
  computationMethodType: PmUnitEnum;
  isOutlier: boolean;
  createdDateTime: string;
  endDateToggled: boolean;
  endTime?: string | Date;
  startTime?: string | Date;
}

export class SensorAssignmentModelList {
  sensorAssignments: SensorAssignment[];
}

export interface DeviceHistoryRow extends SensorAssignment {
  isActive: boolean;
  durationText: string;
}
